import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element'
import './plugins/editor'
import './plugins/filter'
import './plugins/directive'
// 百度埋点
import './plugins/baiduBurialPoint'
import axios from 'axios'
import VueAxios from 'vue-axios'
import property from '../vue-property'
import VueQuillEditor from 'vue-quill-editor'

import { setRegionData } from "@/utils/cityCode"

// iconfont
import "@/assets/iconfont/iconfont.css";

/**
 * require styles
 * 富文本样式
 */
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor)
Vue.use(VueAxios, axios)
Vue.use(property)  // 全局变量
Vue.config.productionTip = false

// README: 页面组件的 keep-alive name 由 build/vue-name-loader.js 在编译阶段自动注入（基于文件路径），
// 无需在运行时拦截 Vue.extend。

// 刷新页面就重新拉取省市区
setRegionData();
	
// 主应用
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
